(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('CompanyRuleSearch', CompanyRuleSearch);

    CompanyRuleSearch.$inject = ['$resource'];

    function CompanyRuleSearch($resource) {
        var resourceUrl = 'api/_search/company-rules/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
